<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="container">
    <div class="main-body">
      <div class="row">
        <div class="col-lg-10">
          <div class="d-flex flex-column align-items-center text-center">
            <img  :src="getUrl(Obj.image)" class="rounded-circle avatar-xl cursor-pointer" role="button" alt="Profile" />
            <div class="mt-3">
              <h4>{{ Obj.name }}</h4>
              <p class="text-secondary mb-1">Admin</p>
              <p class="text-muted font-size-sm">{{ Obj.address }}</p>
            </div>
          </div>
          <hr class="my-4" />
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">Name<sup><span class="text-danger font-12" >*</span></sup> :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.name">
            </div>
            <div class="col-md-4">
              <label class="form-label">Email<sup><span class="text-danger font-12" >*</span></sup> :</label>
              <input type="email" class="form-control form-control-sm" v-model="Obj.email">
            </div>
            <div class="col-md-4">
              <label class="form-label">Phone<sup><span class="text-danger font-12" >*</span></sup> :</label>
              <input type="number" class="form-control form-control-sm" @input="limitDigits($event, 10, v => Obj.phone = v)" v-model="Obj.phone">
            </div>
            <div class="col-md-4">
              <label class="form-label">Password<sup><span class="text-danger font-12" >*</span></sup> :</label>
              <div class="input-group input-group-sm">
              <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="inputPassword" v-model="Obj.password" />
            <span class="input-group-text cursor-pointer bg-white" role="button" @click="togglePassword">
      <i :class="['fa', showPassword ? 'fa-eye' : 'fa-eye-slash' ]"></i>
         </span></div>
            </div>
            <div class="col-md-4">
              <label class="form-label">Address :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.address">
            </div>
            <div class="col-md-4">
              <label class="form-label">Photo :</label>
             <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
         <div class="d-flex align-items-start">
          <a :href="getUrl(Obj.image)" target="_blank"  class="clearfix">{{Obj.image.substring(Obj.image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.image !== ''" @click="deleteFile(Obj.image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
            <div class="col-md-4">
              <label class="form-label"><b>Change Password</b></label>
              <div class="col-12">
                <label class="form-label">New Password :</label>
                <input type="text" class="form-control form-control-sm" v-model="Obj.newPassword">
              </div>
              <div class="col-12 mt-3">
                <label class="form-label">Confirm Password :</label>
                <input type="text" class="form-control form-control-sm" v-model="Obj.confirmPassword">
              </div>
            </div>
            <div class="col-md-12 text-end mb-2">
              <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i class="fa fa-save"></i> Save</button>
          </div>
          </div>
           <ul v-if="errors.length" class="text-danger ps-3">
              <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useStore } from 'vuex'
const store = useStore()
console.log(store)
const userId = store.state.userID;
  const  Obj = ref( { name: "", email: "", phone: "", password: "", address: "", newPassword: "", confirmPassword: "", image: "", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   errors= ref({})
    const  List= ref([])
     const EditMode= ref(false)
    const showPassword = ref(false)
    const  togglePassword= ()=> {
  showPassword.value = !showPassword.value
    }
    const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
   const save = async () => {
  const fields = {
    Name: { value: Obj.value.name, validators: [isRequired], },
    Email: { value: Obj.value.email, validators: [isRequired], },
     Phone: { value: Obj.value.phone, validators: [ (v) => { if (!v) return "Phone No. is required"; if (v.length < 10) return "Phone No. must be 10 digits"; return null; }, ], },
  };
  if (!EditMode.value) {
    fields.Password = { value: Obj.value.password, validators: [isRequired], };
  }
  if (Obj.value.newPassword || Obj.value.confirmPassword) {
    if (Obj.value.newPassword !== Obj.value.confirmPassword) {
      errors.value = {
        ...errors.value,
        PasswordMismatch: "New password and confirm password do not match",
      };
      return;
    } else {
      Obj.value.password = Obj.value.newPassword;
    }
  }
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/Profile${url}`, Obj.value)
      .then((response) => {
        loadData();
        reset();
        msgObj.value = {
          msg: `Profile ${msg} Successfully`,
          role: "success",
          show: true,
        };
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.image = uploadedFile; }
  event.target.value = null;
};
const reset= async() =>{
  Obj.value = { name: "", email: "", phone: "", password: "", address: "", newPassword: "", confirmPassword: "", image: "", };
  msgObj.value = { msg: "", role: "", show: false, };
  errors.value={};
}
const loadData = async () => {
  if (!userId) {
    console.warn("User ID not found in store.");
    return;
  }
  await api.get(`/Profile/${userId}`)
    .then((response) => {
      Obj.value.name = response.data.name;
      Obj.value.email = response.data.email;
      Obj.value.phone = response.data.phone;
      Obj.value.password ='';
      Obj.value.address = response.data.address||'';
      Obj.value.image = response.data.image||'';
      Obj.value._id = response.data._id;
      List.value = response.data;
          if (response.data.length > 0) {
            Obj.value.address = response.data.address;
            Obj.value.image = response.data.image;
            Obj.value._id = response.data._id;
          }
      EditMode.value = true;
    })
    .catch((err) => { console.error("Failed to load profile:", err); });
};
    const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
   const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/default.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;
  
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
  onMounted(() => { loadData() })
</script>